import { ImageComponent } from 'components/Image';
import { LocalizedLink } from 'components/LocalizedLink';
import { ALLOWED_DOMAINS } from '../../helper';
import { LICENSE_BADGES } from './helpers';
import { ScLicenses } from './styled';

interface ILicensesProps {
  // false renders the badges as plain images (e.g. promo landings)
  withLinks?: boolean;
}

export const Licenses = ({ withLinks = true }: ILicensesProps) => {
  const isAllowedDomain = ALLOWED_DOMAINS.includes(window.location.hostname);

  return (
    <ScLicenses>
      <div className={withLinks ? 'licenses' : 'licenses no-links'}>
        {LICENSE_BADGES.filter(
          ({ allowedDomainsOnly }) => !allowedDomainsOnly || isAllowedDomain
        ).map(({ name, alt, src, width, href }) => {
          const image = (
            <ImageComponent
              alt={alt}
              className={`license-${name}`}
              height={44}
              src={src}
              width={width}
            />
          );

          return (
            <div key={name}>
              {withLinks ? (
                <LocalizedLink href={href} target={'_blank'}>
                  {image}
                </LocalizedLink>
              ) : (
                image
              )}
            </div>
          );
        })}
      </div>
    </ScLicenses>
  );
};
